import React from "react";
import { Helmet } from "react-helmet";

import { StylesProvider, ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";

import RouterConfig from "./router";
import maTheme from "./theme";

const App = () => (
    <>
        <Helmet>
            <title>restify.one — админка</title>
        </Helmet>
        <StylesProvider injectFirst>
            <MuiThemeProvider theme={maTheme[0]}>
                <ThemeProvider theme={maTheme[0]}>{RouterConfig()}</ThemeProvider>
            </MuiThemeProvider>
        </StylesProvider>
    </>
);

export default App;
